import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import reducer from './features/';
import { setLayout } from './features/layout';
// import api from './lib/api';

let mode = 'fullscreen';
const fullScreenContainer = document.getElementById('habit-hacker-full');
const popupContainer = document.getElementById('habit-hacker-cta');

const store = configureStore({
    middleware: [thunk],
    reducer,
});

let renderContainer = fullScreenContainer;

if (popupContainer) {
    mode = 'popup';
    renderContainer = popupContainer;
}

store.dispatch(setLayout(mode));
// api.dispatch = store.dispatch;

ReactDOM.render(
    <React.StrictMode>
        <HashRouter>
            <Provider store={store}>
                <App mode={mode} />
            </Provider>
        </HashRouter>
    </React.StrictMode>,
    renderContainer,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
reportWebVitals(console.log);
